import React from "react";

import Background from "../../../assets/cleaning/cleaning-bg-01.png";
import Image from "../../../assets/cleaning/cleaning-choice-b.png";

import GamePageLayout from "../GamePageLayout";

const CleaningPage4 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("weekend")}
    >
      맥주도 마셨고 졸린데,
      <br />
      언제 걸레질을 하고 앉아있어.
      <br />
      간단하게 청소포로 해버리자.
    </GamePageLayout>
  );
};

export default CleaningPage4;
